<template>
  <div v-if="owners">
    <h3 v-if="!hideHeader" class="blue-grey--text text--darken-1 mt-1">{{ (!customHeader) ? title(ownershipType) : customHeader }}</h3>
    <p class="text-left">
      <span v-for="(co, i) in sortedOwners" :key="i">
        <span v-if="co.isPrimary">
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
              <font-awesome-icon icon="paw" color="primary"
                v-bind="attrs" v-on="on" />
            </template>
            <span>{{ tooltipText(ownershipType) }}</span>
          </v-tooltip>
        </span>
        <span v-else>
          <font-awesome-icon icon="paw" color="transparent" />
        </span>
        {{ co.firstName }}
        {{ co.lastName }}
        <span v-if="co.memberId">
          <span v-if="co.isActiveMember === true || co.isActiveMember === false">
            <b>
              <span v-if="co.memberId">&nbsp;
                (<font-awesome-icon icon="id-card" :color="co.isActiveMember == false ? 'red' : 'green'" />
                  {{co.isActiveMember == false ? ' Expired' : ' Active'}} ID#: {{ co.memberId }})</span>
            </b>
          </span> 
          <span v-else>(Member ID: {{ co.memberId.trim() }})</span>
        </span> 
        <br/>
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export enum OwnershipType {
  Dog = 1,
  Lease = 2,
  Litter = 3,
  Kennel = 4
}

export default Vue.extend({
  name: "CoownersList",
  data: function() {
      return {};
  },
  computed: {
    sortedOwners: function() {
      return this.owners.sort(
        (a: any, b: any) => { 
          if(b.isPrimary) 
            return 1;
           else
            return -1; 
      });
    }
  },
  methods: {
      title(ownershipType: OwnershipType){
        if(ownershipType == OwnershipType.Lease){
            return "Lessees";
        } else {
          return "Owners";
        }
      },
      tooltipText(ownershipType: OwnershipType){
        if(ownershipType == OwnershipType.Lease){
            return "Only the primary lessee can register litters, release and register puppies. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Dog){
            return "Only the primary owner can register litters, and lease the dog. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Kennel){
            return "Only the primary owner can request kennel ownership changes. They will also be a primary contact person for the ASCA office.";
        }
        if(ownershipType == OwnershipType.Litter){
            return "Only the primary owner can register and release puppies from the litter. They will also be a primary contact person for the ASCA office.";
        }
        return "";  
      }
  },
  props: {
    customHeader: { type: String },
    hideHeader: { type: Boolean },
    ownershipType: { type: Number  },
    owners: { type: Array },
    headerText: {type: String}
  },
});
</script>
